var map = {
	"./V.png": "9bc6",
	"./V.svg": "9ab0",
	"./VetsGo-Login-01.svg": "493f",
	"./VetsGo-Login-Mobile.svg": "8a23",
	"./VetsGo-Login-Tablet.svg": "5e84",
	"./VetsGo-Login.svg": "aade",
	"./VetsGo.png": "4b51",
	"./add-user-icon.svg": "d468",
	"./avatar-ok.png": "be85",
	"./avatar.png": "4d41",
	"./bg-login-page-dark.svg": "c5ac",
	"./bg-login-page.svg": "b946",
	"./bg-login.png": "19b3",
	"./caret-up-solid.svg": "a348",
	"./carousel/1.jpg": "2bec",
	"./carousel/2.jpg": "949d",
	"./carousel/3.jpg": "22f1",
	"./carousel/4.jpg": "8835",
	"./carousel/5.jpg": "a17f",
	"./carousel/6.jpg": "7fc3",
	"./carousel/7.jpg": "ecd0",
	"./carousel/8.jpg": "03c5",
	"./carousel/clock.png": "5056",
	"./carousel/isa_indicatori.png": "1864",
	"./doctor.png": "1ef2",
	"./error-illustration.svg": "9487",
	"./favicon.ico": "fbec",
	"./food-beverage-1.jpg": "80660",
	"./food-beverage-10.jpg": "b1c5",
	"./food-beverage-11.jpg": "526f",
	"./food-beverage-12.jpg": "9d0b",
	"./food-beverage-13.jpg": "2116",
	"./food-beverage-14.jpg": "e42d",
	"./food-beverage-15.jpg": "920cb",
	"./food-beverage-16.jpg": "4b68",
	"./food-beverage-17.jpg": "2279",
	"./food-beverage-18.jpg": "71b4",
	"./food-beverage-19.jpg": "3708",
	"./food-beverage-2.jpg": "dfc9",
	"./food-beverage-3.jpg": "f005",
	"./food-beverage-4.jpg": "83f8",
	"./food-beverage-5.jpg": "aa10",
	"./food-beverage-6.jpg": "f8a9",
	"./food-beverage-7.jpg": "58ad",
	"./food-beverage-8.jpg": "d32c",
	"./food-beverage-9.jpg": "4c7c",
	"./fotoTest.png": "f61c",
	"./fotoTestCane.jpg": "d27e",
	"./illustration.svg": "643f",
	"./isologo.png": "b1b1",
	"./logo-blue.svg": "e942",
	"./logo-cvit.png": "92a2",
	"./logo.png": "9d64",
	"./logo.svg": "e347",
	"./map-marker-region.png": "1976",
	"./map-marker.png": "4fad",
	"./newLogo.png": "d4c0",
	"./newLogoWhite.png": "6ee6",
	"./newLogo_blue.png": "8cc0",
	"./newLogo_white.png": "1232",
	"./phone-illustration.svg": "4664",
	"./placeholders/200x200.jpg": "f866",
	"./placeholders/800x800.jpg": "f46d",
	"./preview-1.jpg": "fed3",
	"./preview-10.jpg": "cf2e",
	"./preview-11.jpg": "7531",
	"./preview-12.jpg": "c832",
	"./preview-13.jpg": "88d3",
	"./preview-14.jpg": "499f",
	"./preview-15.jpg": "3bac",
	"./preview-16.jpg": "60d7",
	"./preview-17.jpg": "b717",
	"./preview-18.jpg": "dabb",
	"./preview-19.jpg": "e3f4",
	"./preview-2.jpg": "d1e8",
	"./preview-3.jpg": "2bee",
	"./preview-4.jpg": "a3f7",
	"./preview-5.jpg": "0c34",
	"./preview-6.jpg": "b30e",
	"./preview-7.jpg": "56b1",
	"./preview-8.jpg": "dfad",
	"./preview-9.jpg": "7b28",
	"./profile-1.jpg": "317b",
	"./profile-10.jpg": "99b3",
	"./profile-11.jpg": "6874",
	"./profile-12.jpg": "d662",
	"./profile-13.jpg": "c084",
	"./profile-14.jpg": "2208",
	"./profile-15.jpg": "dd46",
	"./profile-16.jpg": "38c7",
	"./profile-17.jpg": "8e75",
	"./profile-18.jpg": "2bd4",
	"./profile-19.jpg": "493b",
	"./profile-2.jpg": "fa45",
	"./profile-3.jpg": "8b0b",
	"./profile-4.jpg": "6a4f",
	"./profile-5.jpg": "df2f",
	"./profile-6.jpg": "e50c",
	"./profile-7.jpg": "28a7",
	"./profile-8.jpg": "8da4",
	"./profile-9.jpg": "535e",
	"./shiba.jpg": "9323",
	"./user.png": "ba97",
	"./vetsGoWhite.png": "5ee6",
	"./vetsGoWhite.svg": "56e3",
	"./vetsGo_White.svg": "0de5",
	"./woman-illustration.svg": "5234"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";